export default "__VITE_ASSET__DuhuR5bh__"